import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';
import { AuthContext } from '../navigation/AuthProvider';
import toast, { Toaster } from 'react-hot-toast';
import styled from 'styled-components';
import { useToast } from '../controller/ToastController';
import { useLocation } from 'react-router-dom';

import LoginController from '../controller/LoginController';
import StoreController from '../controller/StoreController';

export const LoginHotel = (oProps: any) => {
  const showToast = useToast();
  const location = useLocation();

  const queryString = location.search;
  const signupDataString: any = new URLSearchParams(queryString).get('data');
  const signupData = JSON.parse(decodeURI(signupDataString));

  const signupInfo: {
    id: string;
    password: string;
    full_name: string;
    business_name: string;
    business_number: string;
    email: string;
    phone_number: string;
    signup_id: number;
  } = signupData;

  const handleConfirm = async () => {
    try {
      const oRes = await StoreController.signupHotel({ signup_id: signupInfo.signup_id });
      console.log(oRes);
      if (oRes.ok) {
        showToast('회원가입이 완료되었습니다. 로그인해주세요.');
        setTimeout(() => {
          window.location.href = 'https://knock-knock.ivid.kr/hotel/hotelier';
        }, 2000);
      } else {
        showToast(oRes.msg, 'error', 10000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Style>
      <div className="wrap">
        <div className="container">
          <Link to={'/'}>
            <img
              className="logo"
              src={`${process.env.PUBLIC_URL}/svg/ic_logo_black.svg`}
              alt="logo"
              width="100%"
              style={{
                maxWidth: '44px',
              }}
            />
          </Link>
          <h1>호텔 회원가입</h1>
          <h2>
            호텔 가입정보를 모두 확인 후,
            <br /> 회원가입 승인을 진행해주세요.
          </h2>

          <div className="title">
            <h2>호텔명</h2>
          </div>
          <h2>{signupInfo?.business_name}</h2>

          <div className="title">
            <h2>ID</h2>
          </div>
          <h2>{signupInfo?.id}</h2>

          <div className="title">
            <h2>대표자</h2>
          </div>
          <h2>{signupInfo?.full_name}</h2>

          <div className="title">
            <h2>사업자번호</h2>
          </div>
          <h2>{signupInfo?.business_number}</h2>

          <div className="title">
            <h2>전화번호</h2>
          </div>
          <h2>{signupInfo?.phone_number}</h2>

          <div className="title">
            <h2>이메일</h2>
          </div>
          <h2>{signupInfo?.email}</h2>

          <button onClick={handleConfirm} className="successButton">
            회원가입 승인
          </button>
        </div>
      </div>
      <Toaster />
    </Style>
  );
};

export const Style = styled.div`
  .wrap {
    width: 100%;
    height: 100%;
    background: #f8fafc;
  }
  .container {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    min-height: 100vh;
    min-height: 100dvh;
    padding: 20px 4vw !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  ul,
  li,
  a {
    list-style: none;
  }
  h1 {
    margin: 24px 0 12px 0;
    font-size: 26px;
    font-weight: 700;
    color: #26282c;
  }
  h2 {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    color: #555555;
  }

  /* title */
  .title {
    width: 100%;
    margin: 20px 0 0px 0;
    padding: 8px 16px;
    border-radius: 5px;
    background: #ecf5f3;

    h2 {
      font-size: 16px;
    }
  }
  .noticeMessage {
    margin-top: 6px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #ff4a4a;
  }
  .noticeMessage.box {
    background: #ff4a4a;
    color: #fff;
    padding: 3px 6px;
    font-size: 10px;
    border-radius: 50px;
  }
  .noticeMessage.black {
    color: #000;
  }

  /* pdfList */
  .pdfList {
    width: 100%;
    ul {
      padding: 0;
    }
    li {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      padding: 8px;
      border-radius: 5px;
      border: 1px solid #4dd2ae;

      h2 {
        margin-left: 6px;
        font-size: 14px;
        font-weight: 400;
      }
      a {
        margin-left: auto;
        margin-right: 4px;
        color: #40977f;
        font-size: 14px;
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }

  /* checkbox */
  .checkbox {
    width: 18px;
    height: 18px;
    margin-left: 6px;
    cursor: pointer;
    accent-color: #40977f;
  }

  /* canvasBox */
  .canvasBox {
    width: 100%;
    margin-top: 24px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  .sigCanvas {
    width: 100%;
    height: 170px;
  }

  /* successBox */
  .successBox {
    margin-top: 20px;
    width: 100%;
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #4dd2ae;
    text-align: center;

    h2 {
      font-size: 14px;
      font-weight: 700;
      color: #4dd2ae;
    }
  }

  /* successButton */
  .successButton {
    width: 100%;
    margin: 32px 0 12px 0;
    padding: 12px 0;
    background: #4dd2ae;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    border-radius: 5px;
    text-align: center;
  }
`;
